// implemented Input Types in CustomFieldComponent

export enum InputType {
	AlignRight = 'AlignRight',
	AlignCenter = 'AlignCenter',
	CustomFieldAvailableInputTypes = 'CustomFieldAvailableInputTypes',
	Date = 'Date',
	Document = 'Document',
	DocumentOrImage = 'DocumentOrImage',
	Dq = 'Dq',
	DqLabel = 'DqLabel',
	DqMulti = 'DqMulti',
	DqRadio = 'DqRadio',
	DurationAsTimeTo = 'DurationAsTimeTo',
	EntryDescriptionMulti = 'EntryDescriptionMulti',
	File = 'File',
	FileLink = 'FileLink',
	GPS = 'GPS',
	Id = 'Id',
	Image = 'Image',
	Integer = 'Integer',
	JaNeinCheckbox = 'JaNeinCheckbox',
	JaNeinNull = 'JaNeinNull',
	JaNeinRadio = 'JaNeinRadio',
	JaNeinToggle = 'JaNeinToggle',
	Kost = 'Kost',
	Label = 'Label',
	LinkButton = 'LinkButton',
	Number = 'Number',
	Password = 'Password',
	Photo = 'Photo',
	Raw = 'Raw',
	Signature = 'Signature',
	String = 'String',
	Textarea = 'Textarea',
	Time = 'Time',
	Uri = 'Uri',
	Verbose = 'Verbose',
	Video = 'Video',
}

export const InputTypeDoc: Record<InputType, string> = {
	[InputType.AlignRight]: 'rechtsbündig',
	[InputType.AlignCenter]: 'zentriert',
	[InputType.CustomFieldAvailableInputTypes]: 'Verwendbare Werte in CFDef.input (inkl. Dokumentation der notwendigen Parameter zur Verwendung)',
	[InputType.Date]: 'Datepicker',
	[InputType.Document]: 'Dokument mittels Drag & Drop hinzufügen. Benötigt type="B"',
	[InputType.DocumentOrImage]: 'Dokument oder Bild mittels Drag & Drop hinzufügen. Benötigt type="B"',
	[InputType.Dq]: 'Dropdown Eingabefeld (Select)',
	[InputType.DqLabel]: 'Dropdown, das den "value" der Datenquelle ausblendet (es kann "labelkey" zusätzlich zu "value" und "label" verwendet werden)',
	[InputType.DqMulti]: 'Dropdown Eingabefeld (MultiSelect). Mehrere Werte werden in einen String serialisiert. Trennzeichen wird mit CFAttrKey="separator" parametriert. cfdef.type = C verwenden!',
	[InputType.DqRadio]: 'Datenquelleninhalt wird durch Radio-Buttons dargestellt',
	[InputType.DurationAsTimeTo]: 'Zeitspanne (zsp) umformen in Biszeit (für von/bis Buchungen wie im onClient). Benötigt CFAttrKey="TimeFromAttr"',
	[InputType.EntryDescriptionMulti]: 'MultiInput für Buchung/Persurl-Typen. Mehrere Werte (typemap2.id) werden in einen String serialisiert. Trennzeichen wird mit CFAttrKey="separator" parametriert. cfdef.type = C verwenden!',
	[InputType.File]: 'Datei mittels Drag & Drop hinzufügen. Benötigt type="B"',
	[InputType.FileLink]: 'Anzeige der Datei mit der ID im PERSISTIERTEN Modell oder cfdef.defaultvalue',
	[InputType.GPS]: 'GPS Input. Generiert Daten in cf_gps: lat,lon!',
	[InputType.Id]: 'Für ganzzahlige IDs; rechtsbündig.',
	[InputType.Image]: 'Bilder mittels Drag & Drop hinzufügen. Benötigt type="B"',
	[InputType.Integer]: '(alias) Number Input',
	[InputType.JaNeinCheckbox]: 'Checkbox für J/N Feld (benötigt default!)',
	[InputType.JaNeinNull]: 'Tri-PersInfState Select für z.B. persurl.offen_kz',
	[InputType.JaNeinRadio]: 'Radio Button Group die ein nachträgliches Löschen nicht mehr ermöglicht',
	[InputType.JaNeinToggle]: 'Toggle Switch für J/N Feld (benötigt default!)',
	[InputType.Kost]: 'Kostenstelle auswählen. Nur in Apps mit KostModule verwendbar (z.B. sheet). KBerschl angewendet.',
	[InputType.Label]: 'Nur Label wird angezeigt. (Kein cf.-dstField verwenden!)',
	[InputType.LinkButton]: 'Button mit href, der aus der Datenquelle kommt. CFDef Implementierung des DqButton, die allerdings die Parametrierung aus dem CFDef übernimmt. cfDef.dstField = "_dummy" ! ',
	[InputType.Number]: 'Dezimalzahlen unter berücksichtiung Komma oder Punkt und Rundung',
	[InputType.Password]: 'Passwort Eingabefeld; Werte durch Punkte ersetzt.',
	[InputType.Photo]: 'Bilder mittels Drag & Drop hinzufügen. Benötigt type="B"',
	[InputType.Raw]: '(noch nicht implementiert in react)',
	[InputType.Signature]: 'Unterschrift erfassen. Benötigt type="B"',
	[InputType.String]: 'Standard-Eingabefeld',
	[InputType.Textarea]: 'Standard-Eingabefeld, Zeilenvorschub (new line) erlaubt',
	[InputType.Time]: 'Standard-Eingabefeld',
	[InputType.Uri]: 'Wert wird in textueller Darstellung als Link angezeigt',
	[InputType.Verbose]: '(noch nicht implementiert in react)',
	[InputType.Video]: 'Video mittels Drag & Drop hinzufügen. Benötigt type="B"',
} as const
